import { Theme } from '@mui/material';

const useStyles = (theme: Theme) => ({
  file: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px',
    pr: '36px',
    borderRadius: '4px',
    background: theme.palette.common.white,
    position: 'relative',
    height: 'auto',
    overflow: 'hidden',
  },
  // *: The row and its thumbnail -- the download button when the file can download.
  // *: `cursor: pointer` lives here, not on `file`, since this is the box that
  // *: actually carries the click/keydown handlers.
  fileContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '4px',
    outline: 'none',
    cursor: 'pointer',
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '2px',
    },
  },
  fileContentPending: {
    opacity: 0.6,
    cursor: 'progress',
  },
  blockedLink: {
    display: 'block',
    mt: '4px',
    fontSize: '12px',
    fontWeight: 600,
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  rowContainer: {
    display: 'flex',
    gap: '12px',
  },
  fileNameWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  fileName: {
    fontSize: '14px',
    fontWeight: 700,
    color: theme.palette.grey[500],
    textTransform: 'uppercase',
  },
  fileSize: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.grey[400],
  },
  removeBtn: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
});

export default useStyles;
